
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-fill",attrs:{"fill":"#D0EFEC","d":"M29.292 24.864c.86-.741 1.708-2.054 1.708-3.45C31 18.976 28.968 17 26.461 17c-1.392 0-2.646 1.088-3.478 2.049-.833-.947-2.063-2.025-3.444-2.025C17.032 17.024 15 19 15 21.438c0 1.374.651 2.474 1.659 3.412L22.983 31z"}}),_c('path',{staticClass:"i-Union",attrs:{"stroke":"#234652","d":"m17.354 34.646-.147-.146H4.5v-26h39v26H30.793l-.147.146L24 41.293z"}}),_c('path',{staticClass:"i-Union_2",attrs:{"stroke":"#234652","d":"m29.966 22.486-.012.01-.01.01-5.961 5.796-5.976-5.81-.008-.008c-.941-.877-1.499-1.853-1.499-3.046 0-2.149 1.795-3.914 4.039-3.914.559 0 1.116.219 1.651.574.534.354 1.017.826 1.417 1.28l.378.431.376-.433c.398-.46.886-.937 1.427-1.295.542-.36 1.108-.581 1.673-.581 2.244 0 4.039 1.765 4.039 3.914 0 1.208-.747 2.393-1.535 3.072Z"}})])
          )
        }
      }
    